var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUnCheckbox = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 0.75H14.2222C14.7898 0.75 15.25 1.21015 15.25 1.77778V14.2222C15.25 14.7898 14.7898 15.25 14.2222 15.25H1.77778C1.21015 15.25 0.75 14.7898 0.75 14.2222V1.77778C0.75 1.21015 1.21015 0.75 1.77778 0.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnCheckbox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/unCheckbox.02bc034e.svg";
export { ForwardRef as ReactComponent };